import React, { useState } from "react";
import classnames from "classnames";
import style from "./Tabs.module.scss";
import GA from "../../../../common/services/GA";

interface Tab {
  name: string;
  content: React.ReactElement;
}

interface TabsProps {
  data: Tab[];
}

const Tabs: React.FC<TabsProps> = ({ data }) => {
  const [activeTab, setActiveTab] = useState(0);

  const onClickTab = (index: number, name: string): void => {
    setActiveTab(index);
    GA.sendEvent("click", "tab_click", name);
  };

  return (
    <div className={style.tabs}>
      <div className={style.tabs__buttonWrapper}>
        {data.map((item, index) => {
          return (
            <div
              key={index}
              className={classnames(style.tabs__button, {
                [style.tabs__button_active]: index === activeTab,
              })}
              onClick={() => onClickTab(index, item.name)}
            >
              {item.name}
            </div>
          );
        })}
      </div>
      <div className={style.tabs__contentWrapper}>
        <div className={style.tabs__content}>{data[activeTab].content}</div>
      </div>
    </div>
  );
};

export default Tabs;
